// Copyright 2018 Sisense Inc. All rights reserved.

/**
 * @fileoverview Component ready event class.
 * @author artem.lit@sisense.com (Artem Lytvynov).
 * @copyright Sisense Inc.
 * @licence Sisense License.
 */

'use strict';

const Event = require('@sbi/core.events').Event;

/**
 * This event should be fired after component's render method will be called,
 * component will be initialized, attached to the document and ready for further
 * usage. To trigger this event Component#dispatchReadyEvent method should be
 * used.
 * @extends {Event}
 */
class ComponentReady extends Event {
    /**
     * Class constructor.
     * @param {Component} target
     * @constructor
     */
    constructor(target) {
        // noinspection JSCheckFunctionSignatures
        super('componentready', target);
    }
}

// Exports:
exports.ComponentReady = ComponentReady;
